import React from "react";
import classes from "./style.module.scss";
import { Stat } from "../Results/General";

const TransportationInfo = ({
    transportationResults: {
        totalAnnualElectricityConsumption = 0,
        totalAnnualFuelConsumption = 0,
        totalAnnualCost = 0,
        totalAnnualEmissions = 0,
    } = {},
}) => {
    return (
        <>
            <h3 style={{ marginBottom: "1rem", marginTop: "1.5rem" }}>Transportation</h3>

            <div
                className={`${classes.row} ${classes.consumption}`}
                style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", marginBottom: 0 }}
            >
                <Stat label="Electricity" value={totalAnnualElectricityConsumption} decimals={2} unit="kWh" />
                <Stat label="Gasoline/Diesel" value={totalAnnualFuelConsumption} decimals={2} unit="L" />
                <Stat label="Emissions" value={totalAnnualEmissions / 1000} decimals={2} unit="tCO₂/y" />
                <Stat label="Cost" value={totalAnnualCost} decimals={2} unit="$" />
            </div>
        </>
    );
};

export default TransportationInfo;
